
export default {
    
    doInitStore({ commit }, payload){
        return new Promise((resolve, reject) => {
            if (payload.user) {
                commit('setInitStoreUser', payload.user)
                resolve(payload.user)
            }

            if (payload.ColorPalette) {
                commit('setInitStoreColorPalette', payload.ColorPalette)
                resolve(payload.ColorPalette)
            }
        });        
        
    },
    
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/actions/storesActions.js